export const MODULE_TYPES = {
  VOCABULARY: 1,
  GRAMMAR: 2,
}

export const ACTIVITY_TYPES = {
  NONE: -1,
  WORDS_TO_REMEMBER: 1,
  PICTURE_AND_QUESTION: 2,
  MATCHING: 4,
  LISTEN_AND_CHOOSE: 6,
  EXPLANATION: 9,
  TRANSFORMING_SENTENCES: 11,
  FILLING_THE_BLANKS: 12,
  SCRAMBLED_SENTENCES: 14,
  DICTATION: 17,
  WRITTEN_COMPREHENSION: 18,
  JUST_WRITE: 19,
  VIDEO_EXPLANATION: 20,
  MATCHING_AUDIOS: 23,
  ORAL_COMPREHENSION: 26,
  WORDS_PRONOUNCIATION: 28,
  SENTENCE_PRONOUNCIATION: 29,
  READING_OUTLOUD: 31,
  JUST_TALK: 32,
  TEXT_COMPREHENSION: 33,
  ORAL_COMPREHENSION_LONG: 34,
  ORAL_COMPREHENSION_SHORT: 35,
  FILLING_THE_BLANKS_WRITE: 36,
  WRITTEN_ESSAY: 37,
  INTERVIEW: 38,
  ORAL_PRESENTATION: 39,
  FIND_THE_PICTURE: 40,
  LISTEN_AND_FIND_THE_PICTURE: 41,
  SOACKED_MAN: 43,
  MATCHING_PICTURES: 44,
  RECORDING_COMPREHENSION: 47,
  COMPARATIVE_ESSAY: 48,
  JUST_WRITE_MULTIPLE: 49,
  JUST_TALK_MULTIPLE: 50,
  INTERACTIONS: 51,
  PICTURE_AND_QUESTION_WRITE: 52,
  ESSAY: 54,
  MULTIPLE_QUESTIONS: 55,
  READ_WITH_ME: 56,
  FIND_THE_PICTURE_FIXED: 57,
  FIND_THE_PICTURE_MULTIPLE: 58,
  SCRAMBLED_PICTURES: 59,
  SOACKED_MAN_SIMPLIFIED: 60,
  COMPREHENSION: 61,
  CATEGORY_ORGANIZATION: 62,
  CONNECTING_LINES: 63,
  MEMORAMA: 68,
  WORD_SEARCH: 69,
  CROSSWORD: 70,
}

export const FILE_TYPES = {
  TEXT: -1,
  AUDIO: 1,
  IMAGE: 2,
  VIDEO: 3,
}

export const LANGUAGES = {
  1: "es-MX",
  2: "en-US",
  3: "fr-FR",
}

export const SUPPORTED_LANGUAGES = ["en", "es", "fr", "EN", "ES", "FR"]

export const LANGUAGES_NAME = {
  SPANISH: 1,
  ENGLISH: 2,
  FRENCH: 3,
}

export const ACTIVITY_VIEW_MODES = {
  STUDENT: 1,
  EXPLANATION: 2,
  TEACHER_MODULE: 3, // SEE ALL ACTIVITIES BUT CAN'T UPDATE GRADES
  TEACHER_ACTIVITY: 4, // FILTER TO SEE ONLY CURRENT ACTITY IN FOOTER, CAN'T UPDATE GRADES
  TEACHER_ACTIVITY_GRADE_EDIT: 5, // SEE ALL ACTIVITIES AND CAN UPDATE GRADES
  TEACHER_EXERCISE_GRADE: 6, // FILTER TO SEE ONLY CURRENT EXERCISE, HIDE FOOTER, CAN SEND TEACHER COMMENTS
  TEACHER_MODULE_BASE: 7, // SEE ALL ACTIVITIES BUT CAN'T UPDATE GRADES, LOAD FROM BASE
  TEACHER_ACTIVITY_BASE: 8, // FILTER TO SEE ONLY CURRENT ACTITY IN FOOTER, CAN'T UPDATE GRADES, LOAD FROM BASE
  PLACEMENT_TEST: 9, // LOAD FROM BASE, AND UPDATE GRADE INTO PLACEMENT TEST ENDPOINTS
  GAMES: 2, // LOAD FROM BASE, CAN'T UPDATE GRADES
  PROFESSOR: 10, // TEACHER ROLE
}

export const TEACHER_VIEWS = [
  ACTIVITY_VIEW_MODES.TEACHER_MODULE,
  ACTIVITY_VIEW_MODES.TEACHER_ACTIVITY,
  ACTIVITY_VIEW_MODES.TEACHER_ACTIVITY_GRADE_EDIT,
  ACTIVITY_VIEW_MODES.TEACHER_EXERCISE_GRADE,
  ACTIVITY_VIEW_MODES.TEACHER_MODULE_BASE,
  ACTIVITY_VIEW_MODES.TEACHER_ACTIVITY_BASE,
]

export const CONTENT_TYPES = {
  WORD: 1,
  EXPLANATION: 2,
  QUESTION: 3,
  ANSWER: 4,
  DESCRIPTION: 6,
  RELATE_A: 7,
  RELATE_B: 8,
  TEXT: 9,
  EXAMPLE: 10,
  TO_REPLACE: 11,
  REPLACED: 12,
  INSTRUCTIONS: 13,
  INTERVIEWER: 16,
  INTERVIEWED: 17,
  PHRASE: 14,
  MULTIMEDIA: 18,
  TEXTLV2: 19,
  TEXTLV3: 20,
}

export const ANSWER_TYPES = {
  CORRECT: 100,
  WRONG: 0,
  WRITE: 1,
  RECORD: 2,
}

export const ANSWER_VERSION = 3

export const ACTIVITY_ATTEMPS = {
  SOACKED_MAN: 4,
  FILLING_THE_BLANKS_WRITE: 4,
  PICTURE_AND_QUESTION_WRITE: 4,
  DICTATION: 4,
  SENTENCE_PRONOUNCIATION: 5,
  INTERACTIONS: 5,
  WORDS_TO_REMEMBER: 5,
  WORDS_PRONOUCIATION: 5,
  READING_OUT_LOUD: 5,
  EXAM: 1,
  READ_WITH_ME: 5,
  TRANSFORMING_SENTENCES: 4,
  PHONETICS: 5,
}
/**
 * @description time limit for voice recording in seconds.
 */
export const ACTIVITY_RECORDING_TIME = {
  JUST_TALK: 240,
  JUST_TALK_MULTIPLE: 60,
  INTERVIEW: 78,
  SENTENCE_PRONOUNCIATION: 20,
  INTERACTIONS: 45,
}

export const MODULE_TEMPLATE_LANGUAGES = {
  SPANISH: 1,
  ENGLISH: 2,
  FRENCH: 3,
}

export const MODULE_STREAK_ACTIVITY = 4
export const MODULE_STREAK_EXERCISE = 8

export const ESPECIAL_CHARACTERS = [
  "'",
  "¡",
  "!",
  "?",
  "¿",
  "-",
  "_",
  ";",
  ":",
  ".",
  ",",
  "&",
  "«",
  "»",
]

export const MODULE_ASSIGN_TYPES = {
  EXAM: 3,
}

export const MIN_GRADE_TO_PASS = 70

export const LOG_STATUS_TYPES = {
  TEMPORAL: "Temporal",
  FINAL: "Final",
  DISCARTED: "Discarded",
}
